import React, { Component } from "react";
import PageCurtain from "./page-curtain/index";
import { connect } from "react-redux";

class Transition extends Component {
  render() {
    if (
      this.props.pageTransition.transition &&
      this.props.pageTransition.transition.name === "page-curtain"
    ) {
      return <PageCurtain {...this.props.pageTransition.transition} />;
    } else {
      return null;
    }
  }
}

const mapStateToProps = state => {
  return {
    pageTransition: state
  };
};

export default connect(mapStateToProps, null)(Transition);
